class FreeShippingPopup extends HTMLElement {
  constructor() {
    super();

    const template = this.querySelector('template');
    if (!template) return;

    this.templateRoot = this.attachShadow({ mode: 'open' });
    this.templateRoot.appendChild(template.content.cloneNode(true));

    this.threshold = Number(this.dataset.threshold || 0);
    this.storageKey = 'ziggyFreeShippingLastTotal';
    this.bubble = document.getElementById('cart-icon-bubble');

    this.rememberTotal(Number(this.dataset.cartTotal || 0));

    if (this.bubble) {
      this.observer = new MutationObserver(this.handleBubbleChange.bind(this));
      this.observer.observe(this.bubble, { childList: true, subtree: true });
    }

    const closeButton = this.templateRoot.querySelector('[data-free-shipping-popup-close]');
    if (closeButton) closeButton.addEventListener('click', this.hide.bind(this));
  }

  handleBubbleChange() {
    const totalElement = this.bubble.querySelector('[data-cart-total]');
    if (!totalElement) return;

    const total = Number(totalElement.dataset.cartTotal || 0);
    const previousTotal = this.getRememberedTotal();
    this.rememberTotal(total);

    if (this.threshold > 0 && previousTotal < this.threshold && total >= this.threshold) {
      this.show();
    }
  }

  getRememberedTotal() {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored === null ? Number(this.dataset.cartTotal || 0) : Number(stored);
  }

  rememberTotal(total) {
    sessionStorage.setItem(this.storageKey, total);
  }

  show() {
    clearTimeout(this.hideTimeout);
    this.classList.add('active');
    this.hideTimeout = setTimeout(this.hide.bind(this), Number(this.dataset.duration || 6000));
  }

  hide() {
    clearTimeout(this.hideTimeout);
    this.classList.remove('active');
  }
}

if (!customElements.get('free-shipping-popup')) {
  customElements.define('free-shipping-popup', FreeShippingPopup);
}
